// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headCellMembers__VIteeSKaYa{width:20%}.headCellActions__bmQXOcIFQc{width:100px}.cellActions__nI5H2mYTdn{text-align:right}`, "",{"version":3,"sources":["webpack://./src/assets/components/settings/teams/components/teams.module.scss"],"names":[],"mappings":"AAEA,6BACE,SAAA,CAGF,6BACE,WAAA,CAGF,yBACE,gBAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.headCellMembers {\n  width: 20%;\n}\n\n.headCellActions {\n  width: 100px;\n}\n\n.cellActions {\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headCellMembers": `headCellMembers__VIteeSKaYa`,
	"headCellActions": `headCellActions__bmQXOcIFQc`,
	"cellActions": `cellActions__nI5H2mYTdn`
};
export default ___CSS_LOADER_EXPORT___;
